var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.1 5.5h14.3v6.9H14.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 31.1,
    cy: 18.4,
    r: 2.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M5.6 17.3v7.9c0 2.6 2.1 4.7 4.7 4.7h3.8M28.4 29.9h3.8c2.6 0 4.7-2.1 4.7-4.7v-7.9c0-2.6-2.1-4.7-4.7-4.7H10.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.1 23.9h14.3V37H14.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.5 23.9h19.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.79861b3091c38dbd9be9c4d37e3c6ac0.svg";
export { ForwardRef as ReactComponent };